import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
} from "./ui/context-menu";
import { Edit, Copy, Trash2 } from "lucide-react";

const ShiftContextMenu = ({
  children,
  shift,
  employee,
  onEdit,
  onCopy,
  onDelete,
  isLocked = false,
}) => {
  const handleEdit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onEdit?.(shift, employee);
  };

  const handleCopy = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onCopy?.(shift, employee);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onDelete?.(shift, employee);
  };

  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>
        {children}
      </ContextMenuTrigger>
      <ContextMenuContent className="w-48" data-testid="shift-context-menu">
        <ContextMenuItem 
          onClick={handleEdit}
          className="cursor-pointer"
          data-testid="context-menu-edit"
        >
          <Edit className="w-4 h-4 mr-2" />
          Edit Shift
        </ContextMenuItem>
        
        <ContextMenuItem 
          onClick={handleCopy}
          className="cursor-pointer"
          disabled={isLocked}
          data-testid="context-menu-copy"
        >
          <Copy className="w-4 h-4 mr-2" />
          Copy Shift
        </ContextMenuItem>
        
        <ContextMenuSeparator />
        
        <ContextMenuItem 
          onClick={handleDelete}
          className="cursor-pointer text-destructive focus:text-destructive focus:bg-destructive/10"
          disabled={isLocked}
          data-testid="context-menu-delete"
        >
          <Trash2 className="w-4 h-4 mr-2" />
          Delete Shift
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
};

export default ShiftContextMenu;
